/**
 * The low-stock warning (T021, FR-309).
 *
 * PERSISTENT, NOT AUTO-DISMISSING. Unlike a claim's success/failure message,
 * this stays on screen for as long as the count is under threshold — closing
 * the till or claiming a code does not make a shrinking pool less true.
 *
 * A CORNER BADGE, NOT A SENTENCE. Now that `WifiVoucherButton` lives in the
 * header bar next to Sales/Menu/Settings, a full paragraph would either wrap
 * the header onto a second line by itself or force every neighbouring button
 * to shrink around it. The count is genuinely useful to a manager deciding
 * whether to rotate the pool tonight, so it stays visible (not hover-only) —
 * just small. `title` carries the fuller sentence for anyone who hovers.
 *
 * PROPS-DRIVEN. No fetch, no subscription of its own — `WifiVoucherButton`
 * already owns the count (it needs the same number to decide the exhausted-
 * pool message), so this is a plain function of `count` and `threshold`
 * rather than a second thing polling the same table.
 */
export interface WifiVoucherLowStockProps {
  count: number;
  threshold: number;
}

export function WifiVoucherLowStock({ count, threshold }: WifiVoucherLowStockProps) {
  if (count >= threshold) return null;

  const sentence =
    count === 0 ? "No WiFi codes left — load a new pool." : `Only ${count} WiFi codes left.`;

  return (
    <span
      className={`wifivoucher__badge${count === 0 ? " is-empty" : ""}`}
      role="status"
      title={sentence}
    >
      {count}
    </span>
  );
}

export default WifiVoucherLowStock;
